// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-badge-content {
  background: #5ea1d8;
}

.bundleIcon {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 10;
  width: 25px;
  height: 25px;
}
.bundleIcon img {
  width: 100% !important;
  height: auto !important;
  object-fit: contain;
  border: none;
}

.main-div {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 89vh;
  background: #efeeee !important;
}
.main-div .main-content {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 20px 30px !important;
  width: 90%;
  max-width: 1000px;
  max-height: auto;
  width: 100%;
  position: relative;
  padding: 0px;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  text-align: center;
}
.main-div .mat-form-field-appearance-legacy .mat-form-field-underline {
  background: lightgray !important;
}
.main-div .font16 {
  font-size: 14px !important;
  font-family: "Raleway";
}
.main-div .table-wrapper .table-inner {
  border-radius: 5px;
  max-height: 300px;
  height: 100%;
  position: relative;
  overflow: hidden;
  min-height: 300px;
  border: 1px solid lightgray;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-div .table-wrapper .table-inner img.img-display {
  max-width: 100%;
  max-height: 250px;
  object-fit: contain;
}
.main-div .table-wrapper .table-inner video.video-display {
  width: 100%;
  height: 100%;
}
.main-div .table-wrapper p {
  color: rgba(0, 0, 0, 0.54) !important;
  text-align: left !important;
  padding: 10px;
  line-height: 20px;
}
.main-div button.close {
  position: absolute;
  top: 20px;
  right: 22px;
  z-index: 1000;
}
.main-div .btn-primary {
  background-color: #5ea1d8;
  border: none;
}
.main-div .flowbycat {
  background-color: transparent;
}
.main-div .hide_file {
  position: absolute;
  z-index: 1000;
  opacity: 0;
  cursor: pointer;
  right: 0;
  top: 0;
  height: 100%;
  font-size: 24px;
  width: 100%;
}
@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .main-div .main-div {
    min-height: 92vh;
  }
  .main-div .main-content {
    width: 75%;
  }
}

@media only screen and (max-width: 767px) and (min-width: 320px) {
  .main-div {
    background: #fff !important;
  }
  .main-div .main-content {
    width: calc(100% - 30px) !important;
    padding: 5px 5px 20px !important;
  }
}
@media (max-width: 460px) {
  .main-div .table-wrapper .table-inner {
    max-height: 150px;
    min-height: 150px;
  }
  .main-div .table-wrapper .table-inner img.img-display {
    max-height: 100px;
  }
  .main-div .table-wrapper .table-inner .video-display {
    max-height: 100px;
  }
}
/*new design starts here*/
.addbundle .user-pro .row {
  text-align: center;
  margin: 0px !important;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.addbundle .user-pro .item {
  margin-right: 0px !important;
  margin-left: 0px !important;
  border: 1px solid #ddd !important;
  margin: 10px !important;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: -2px 2px 7px hsla(0, 6%, 77%, 0.5);
  width: 22% !important;
}
.addbundle .user-pro .item p {
  text-align: left;
}
.addbundle .user-pro .item img {
  border: 1px solid #ddd;
  width: calc(100% - 10px) !important;
  height: 150px !important;
  border-radius: 0 !important;
  margin: 5px !important;
}
.addbundle .user-pro .item .with-icon {
  display: flex;
}
.addbundle .user-pro .item .with-icon > div {
  width: 40px !important;
}
.addbundle .user-pro .item .with-icon img {
  height: 30px !important;
  border-radius: 20px !important;
  object-fit: cover !important;
}
.addbundle .user-pro .mat-checkbox {
  position: absolute;
  top: 5px;
  right: 5px;
}
.addbundle .user-pro .mat-checkbox .mat-checkbox-frame {
  border-color: rgb(94, 161, 216) !important;
}
.addbundle button.tickclass {
  font-size: 30px;
  color: black;
  position: sticky;
  top: 96px;
}
.addbundle button.tickclass .tickico {
  font-size: 22px;
  font-weight: bold;
}
.addbundle input {
  display: flex;
  justify-content: center;
  margin: 0px auto;
  width: 100% !important;
  margin-left: 0px !important;
}

@media (max-width: 1024px) {
  .addbundle .user-pro .row {
    width: 100% !important;
    display: flex;
  }
  .addbundle .user-pro .item {
    width: 30% !important;
    margin: 0px !important;
  }
  .addbundle button.tickclass .tickico {
    font-size: 30px !important;
  }
}
@media (max-width: 460px) {
  .addbundle .user-pro .row {
    width: 100% !important;
    display: flex;
    justify-content: space-between;
  }
  .addbundle .user-pro .item {
    width: 46% !important;
    margin: 5px !important;
  }
}
button.owl-next {
  position: absolute;
  background: #fafafa !important;
  background: rgba(250, 250, 250, 0.7) !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  right: 0px;
}
button.owl-next span {
  font-size: 57px;
  line-height: 0px;
  display: flex;
  align-items: center;
  margin-top: -15px;
  font-weight: 400 !important;
  color: #5ea1d8;
}

.with-icon p {
  margin-top: 0px !important;
}

.stickybtn {
  position: fixed;
  bottom: 20px;
  max-width: 1000px;
  width: 100%;
  padding-right: 50px;
}
.stickybtn button {
  background: rgba(250, 250, 250, 0.7) !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  right: 0px;
  border: 0px;
}

.item {
  border: solid 0.5px lightgrey;
  margin: 5px 20px 0px 0px;
  width: 170px;
}

/* Prevent text/icon overlaps in cards and wrap long strings */
.addbundle .user-pro .item {
  word-break: break-word;
}

.addbundle .user-pro .item p,
.addbundle .user-pro .item .lf13 {
  word-break: break-word;
  white-space: normal;
}

/* Mobile refinements: tighter spacing, no overlaps */
@media (max-width: 460px) {
  .addbundle .user-pro .item img,
  .addbundle .user-pro .item .video-display {
    max-height: 100px !important;
    height: auto;
  }
  .stickybtn {
    padding-right: 10px;
  }
}
/* Flow card alignment styles matching search page */
.video-info {
  display: flex;
  gap: 0;
}

.video-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  margin: 0;
  padding: 0;
}

.video-title-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  margin-bottom: 0 !important;
  padding: 0;
  justify-content: space-between;
}

.video-title {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  margin: 0;
  margin-bottom: 0px !important;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  flex: 1;
  min-width: 0;
  padding: 0;
  padding-right: 4px;
  word-wrap: break-word;
  word-break: break-word;
}

.video-title:hover {
  color: #666666;
}

.channel-meta-row {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
  margin-top: -2px !important;
  padding: 0;
  flex-wrap: nowrap;
  line-height: 1;
  justify-content: space-between;
  position: relative;
}

.channel-meta-row > *:not(.video-views) {
  flex-shrink: 0;
}

.video-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-icon {
  width: 100%;
  height: 100%;
  font-size: 24px;
  color: #212427 !important;
}

.channel-name {
  font-size: 13px;
  color: #606060;
  margin: 0px !important;
  line-height: 1.3;
  cursor: pointer;
  white-space: nowrap;
}

.channel-name:hover {
  color: #000000;
}

.video-views {
  font-size: 12px;
  color: #909090;
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/addflowsin-bundle/addflowsin-bundle.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AACF;AAAE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAEJ;;AAEA;EACE,aAAA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;AACJ;AAAI;EACA,kCAAA;EACA,gBAAA;EACA,6BAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;AAEJ;AACI;EACE,gCAAA;AACN;AAEA;EAAS,0BAAA;EAA2B,sBAAA;AAEpC;AACI;EACM,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACV;AAAU;EAEG,eAAA;EACA,iBAAA;EACA,mBAAA;AACb;AACW;EAAqB,WAAA;EAAa,YAAA;AAG7C;AAAK;EAAE,qCAAA;EAAkC,2BAAA;EAA4B,aAAA;EAAa,iBAAA;AAMlF;AAJA;EACA,kBAAA;EACI,SAAA;EACA,WAAA;EACA,aAAA;AAMJ;AAFA;EAAc,yBAAA;EAA0B,YAAA;AAMxC;AALA;EAAW,6BAAA;AAQX;AAPA;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AASF;AALA;EACE;IACE,gBAAA;EAOF;EALA;IACE,UAAA;EAOF;AACF;;AAHA;EACE;IACE,2BAAA;EAMF;EALE;IACE,mCAAA;IACA,gCAAA;EAOJ;AACF;AAHA;EAEI;IACE,iBAAA;IACA,iBAAA;EAIJ;EAHI;IACE,iBAAA;EAKN;EAHI;IACE,iBAAA;EAKN;AACF;AADA,yBAAA;AAGI;EACE,kBAAA;EAEA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;AAAN;AAEI;EACE,4BAAA;EACA,2BAAA;EAEA,iCAAA;EACA,uBAAA;EACA,gBAAA;EACF,gBAAA;EACA,kBAAA;EACA,8CAAA;EACA,qBAAA;AADJ;AAEI;EACE,gBAAA;AAAN;AAII;EACE,sBAAA;EACA,mCAAA;EACF,wBAAA;EACA,2BAAA;EACA,sBAAA;AAFJ;AAII;EACE,aAAA;AAFN;AAGM;EACE,sBAAA;AADR;AAGM;EAEE,uBAAA;EACA,8BAAA;EACA,4BAAA;AAFR;AAOI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AALN;AAMM;EACE,0CAAA;AAJR;AASE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;AAPJ;AAQI;EACE,eAAA;EACA,iBAAA;AANN;AASA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,sBAAA;EACA,2BAAA;AAPF;;AAWA;EAGM;IACE,sBAAA;IACA,aAAA;EAVN;EAaI;IACE,qBAAA;IACJ,sBAAA;EAXF;EAeA;IACE,0BAAA;EAbF;AACF;AAiBA;EAGM;IACE,sBAAA;IACA,aAAA;IACA,8BAAA;EAjBN;EAmBI;IACE,qBAAA;IACJ,sBAAA;EAjBF;AACF;AAqBA;EACE,kBAAA;EACA,8BAAA;EACA,+CAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;AApBF;AAsBE;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;AApBJ;;AAwBE;EACE,0BAAA;AArBJ;;AAwBA;EACE,eAAA;EAEE,YAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AAtBJ;AAuBI;EACE,+CAAA;EACF,iHAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;AArBJ;;AA6BA;EACE,6BAAA;EACA,wBAAA;EACA,YAAA;AA1BF;;AA6BA,8DAAA;AACA;EACE,sBAAA;AA1BF;;AA4BA;;EAEE,sBAAA;EACA,mBAAA;AAzBF;;AA4BA,qDAAA;AACA;EACE;;IAEE,4BAAA;IACA,YAAA;EAzBF;EA4BA;IACE,mBAAA;EA1BF;AACF;AA6BA,oDAAA;AACA;EACE,aAAA;EACA,MAAA;AA3BF;;AA8BA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,8BAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,6BAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;AA3BF;;AA8BA;EACE,cAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;EACA,8BAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,cAAA;AA3BF;;AA8BA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA3BF;;AA8BA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AA3BF;;AA8BA;EACE,cAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;AA3BF","sourcesContent":[".mat-badge-content {\n  background:#5ea1d8;\n}\n\n.bundleIcon {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  z-index: 10;\n  width: 25px;\n  height: 25px;\n  img{\n    width: 100% !important;\n    height: auto !important;\n    object-fit: contain;\n    border: none;\n  }\n} \n\n.main-div{\n  display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 89vh;\n    background: #efeeee !important;\n    .main-content{\n    border-radius: 10px 10px 10px 10px;\n    background: #fff;\n    padding: 20px 30px !important;\n    width: 90%;\n    max-width: 1000px;\n    max-height:auto;\n    width: 100%;\n    position: relative;\n    padding: 0px;\n    border: 1px solid #ddd;\n    box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n    text-align: center;\n    // border: 0.5px solid lightgrey;\n    }\n    .mat-form-field-appearance-legacy .mat-form-field-underline{\n      background:lightgray !important;\n    }\n\n.font16 {font-size: 14px!important; font-family:\"Raleway\";}\n.table-wrapper{\n\n    .table-inner {\n          border-radius: 5px;\n          max-height: 300px;\n          height: 100%;\n          position: relative;\n          overflow: hidden;\n          min-height: 300px;\n          border: 1px solid lightgray;\n          background: #fff;\n          display:flex;\n          align-items: center;\n          justify-content: center;\n          img.img-display {\n           \n             max-width: 100%;\n             max-height: 250px;\n             object-fit: contain;\n           }\n           video.video-display {width: 100%; height: 100%;}\n    }\n\n     p{color: rgba(0,0,0,.54)!important; text-align:left !important; padding:10px;line-height:20px;}\n}\nbutton.close{\nposition: absolute;\n    top: 20px;\n    right:22px;\n    z-index:1000;\n}\n\n\n.btn-primary {background-color:#5ea1d8; border: none;}\n.flowbycat{background-color: transparent;}\n.hide_file {\n  position: absolute;\n  z-index: 1000;\n  opacity: 0;\n  cursor: pointer;\n  right: 0;\n  top: 0;\n  height: 100%;\n  font-size: 24px;\n  width: 100%;\n}\n\n\n@media only screen and (max-width: 1024px) and (min-width: 768px){\n  .main-div{\n    min-height:92vh;\n  }\n  .main-content{\n    width:75%;\n  }\n}\n}\n\n@media only screen and (max-width: 767px) and (min-width: 320px){\n  .main-div{\n    background:#fff !important;\n    .main-content{\n      width:calc(100% - 30px) !important;\n      padding:5px 5px 20px !important;\n\n    }\n  }\n}\n@media(max-width:460px){\n  .main-div{\n    .table-wrapper .table-inner {\n      max-height: 150px;\n      min-height: 150px;\n      img.img-display{\n        max-height:100px;\n      }\n      .video-display{\n        max-height:100px;\n      }\n    }\n  }\n}\n/*new design starts here*/\n.addbundle{\n  .user-pro{\n    .row{\n      text-align: center;\n\n      margin:0px !important;\n      display: flex;\n      align-items: flex-start;\n      justify-content:flex-start;\n    }\n    .item{\n      margin-right:0px !important;\n      margin-left:0px !important;\n      // width: calc(100% - 10px)!important;\n      border: 1px solid #ddd !important;\n      margin:10px !important;\n      overflow: hidden;\n    background: #fff;\n    position:relative;\n    box-shadow:-2px 2px 7px hsl(0deg 6% 77% / 50%);\n    width:22% !important;\n    p{\n      text-align: left;\n\n    }\n\n    img{\n      border:1px solid #ddd;\n      width: calc(100% - 10px)!important;\n    height: 150px!important;\n    border-radius: 0!important;\n    margin:5px !important;\n    }\n    .with-icon{\n      display:flex;\n      &>div{\n        width:40px !important;\n      }\n      img{\n        // width:100% !important;\n        height:30px !important;\n        border-radius:20px !important;\n        object-fit: cover !important;\n      }\n    }\n\n    }\n    .mat-checkbox{\n      position: absolute;\n      top:5px;\n      right:5px;\n      .mat-checkbox-frame{\n        border-color:rgb(94, 161, 216) !important;\n      }\n    }\n\n  }\n  button.tickclass{\n    font-size: 30px;\n    color: black;\n    position: sticky;\n    top: 96px;\n    .tickico{\n      font-size:22px;\n      font-weight:bold;\n    }\n  }\ninput{\n  display: flex;\n  justify-content: center;\n  margin: 0px auto;\n  width: 100% !important;\n  margin-left: 0px !important;\n  \n}\n}\n@media(max-width:1024px){\n  .addbundle{\n    .user-pro{\n      .row{\n        width:100% !important;\n        display:flex;\n        // justify-content: space-between;\n      }\n      .item{\n        width: 30% !important;\n    margin: 0px !important;\n      }\n    }\n  }\n  .addbundle button.tickclass .tickico{\n    font-size:30px !important;\n  }\n\n}\n\n@media(max-width:460px){\n  .addbundle{\n    .user-pro{\n      .row{\n        width:100% !important;\n        display:flex;\n        justify-content: space-between;\n      }\n      .item{\n        width: 46% !important;\n    margin: 5px !important;\n      }\n    }\n  }\n}\nbutton.owl-next {\n  position: absolute;\n  background: #fafafa !important;\n  background: rgba(250,250,250,0.7) !important;\n  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n    0 1px 18px 0 rgb(0 0 0 / 12%);\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  right: 0px;\n  \n  span {\n    font-size: 57px;\n    line-height: 0px;\n    display: flex;\n    align-items: center;\n    margin-top: -15px;\n    font-weight: 400 !important;\n    color: #5ea1d8;\n  }\n}\n.with-icon{\n  p{\n    margin-top: 0px !important;\n  }\n}\n.stickybtn{\n  position: fixed;\n \n    bottom: 20px;\n    max-width: 1000px;\n    width: 100%;\n    padding-right: 50px;\n    button{\n      background: rgba(250, 250, 250, 0.7) !important;\n    box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    outline: none;\n    right: 0px;\n    border: 0px;\n    }\n}\n// .docs-carousel-nav{\n//   position: fixed !important;\n//  bottom:unset !important;\n//  right:unset !important;\n// }\n.item {\n  border: solid 0.5px lightgrey;\n  margin: 5px 20px 0px 0px;\n  width: 170px;\n}\n\n/* Prevent text/icon overlaps in cards and wrap long strings */\n.addbundle .user-pro .item {\n  word-break: break-word;\n}\n.addbundle .user-pro .item p,\n.addbundle .user-pro .item .lf13 {\n  word-break: break-word;\n  white-space: normal;\n}\n\n/* Mobile refinements: tighter spacing, no overlaps */\n@media (max-width: 460px) {\n  .addbundle .user-pro .item img,\n  .addbundle .user-pro .item .video-display {\n    max-height: 100px !important;\n    height: auto;\n  }\n\n  .stickybtn {\n    padding-right: 10px;\n  }\n}\n\n/* Flow card alignment styles matching search page */\n.video-info {\n  display: flex;\n  gap: 0;\n}\n\n.video-details {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  margin: 0;\n  padding: 0;\n}\n\n.video-title-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0;\n  margin-bottom: 0 !important;\n  padding: 0;\n  justify-content: space-between;\n}\n\n.video-title {\n  font-size: 16px;\n  font-weight: 500;\n  color: #000000;\n  margin: 0;\n  margin-bottom: 0px !important;\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  flex: 1;\n  min-width: 0;\n  padding: 0;\n  padding-right: 4px;\n  word-wrap: break-word;\n  word-break: break-word;\n}\n\n.video-title:hover {\n  color: #666666;\n}\n\n.channel-meta-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  margin: 0;\n  margin-top: -2px !important;\n  padding: 0;\n  flex-wrap: nowrap;\n  line-height: 1;\n  justify-content: space-between;\n  position: relative;\n}\n\n.channel-meta-row > *:not(.video-views) {\n  flex-shrink: 0;\n}\n\n.video-avatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.avatar-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.avatar-icon {\n  width: 100%;\n  height: 100%;\n  font-size: 24px;\n  color: #212427 !important;\n}\n\n.channel-name {\n  font-size: 13px;\n  color: #606060;\n  margin: 0px !important;\n  line-height: 1.3;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.channel-name:hover {\n  color: #000000;\n}\n\n.video-views {\n  font-size: 12px;\n  color: #909090;\n  margin: 0;\n  white-space: nowrap;\n  flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
